import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: <>
          Llevo <strong data-id="element-316">15 años</strong> estudiando la Biblia y{' '}
          <strong data-id="element-317">NUNCA</strong> había entendido la geografía como ahora. Cuando
          vi la reconstrucción 3D de Jerusalén en tiempos de Jesús,{' '}
          <em data-id="element-318">se me puso la piel de gallina</em>. Cada pasaje cobra un
          significado completamente nuevo.
        </>,
    initial: 'R',
    name: 'Roberto M.',
    role: 'Líder de Estudio Bíblico · México'
  }, {
    quote: <>
          Compré un atlas bíblico de <strong data-id="element-319">$90</strong> el año pasado y no se
          compara ni de lejos. Las imágenes de Biblia Visual son{' '}
          <strong data-id="element-320">increíblemente claras</strong> y el contexto arqueológico que
          incluye es de{' '}
          <span className="underline decoration-gold decoration-1 underline-offset-2" data-id="element-321">
            nivel seminario
          </span>
          . Por $14.99 es <strong data-id="element-322">ridículamente bueno</strong>.
        </>,
    initial: 'M',
    name: 'María Elena P.',
    role: 'Maestra de Escuela Dominical · Argentina'
  }, {
    quote: <>
          Lo uso <strong data-id="element-323">cada domingo</strong> para preparar mis sermones. Los
          mapas y las fotos reales hacen que mi congregación entienda los
          pasajes <strong data-id="element-324">como nunca antes</strong>. Ya varios miembros me han
          pedido el enlace para comprarlo ellos también.
        </>,
    initial: 'D',
    name: 'Pastor Daniel R.',
    role: 'Pastor · Colombia'
  }];
  return <section className="py-14 bg-cream" data-id="element-325">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-326">
        <FadeIn data-id="element-327">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-center text-navy-900 mb-8 max-w-3xl mx-auto" data-id="element-328">
            Escucha Lo Que Dicen Nuestros Lectores Satisfechos
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-329">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.12} className="h-full" data-id="element-330">
              <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 h-full flex flex-col" data-id="element-331">
                <div className="flex text-gold mb-3" data-id="element-332">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-333" />)}
                </div>

                <p className="text-sm text-gray-700 italic leading-relaxed mb-4 flex-grow" data-id="element-334">
                  "{t.quote}"
                </p>

                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-335">
                  <div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-bold font-heading text-lg" data-id="element-336">
                    {t.initial}
                  </div>
                  <div data-id="element-337">
                    <h4 className="font-bold text-navy-900 text-sm" data-id="element-338">
                      {t.name}
                    </h4>
                    <p className="text-xs text-gray-500" data-id="element-339">{t.role}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}